<cam-overlay-panel #overlay [panelConfig]="{ matchTriggerWidth: false, manualTrigger: true }" class="d-flex flex-fill">
  <ng-template #panelTrigger>
    <cam-loader [isLoading]="this.requestState.isLoading()">
      <cam-button-tool (action)="this.openMenu()" icon="ia" size="sm"></cam-button-tool>
    </cam-loader>
  </ng-template>
  <ng-template #panelContent>
    @let menu = this.actionMenu();
    <div class="menu-panel">
      @if (menu) {
        <cam-menu [menu]="menu" [style]="'dark'"></cam-menu>
      }
    </div>
  </ng-template>
</cam-overlay-panel>
